import { ArrowRight, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function InquireForServices() {
  return <section id="inquire-for-services" className="bg-primary-500 text-primary-foreground py-16 md:py-24 relative overflow-hidden">
      <div id="connect-with-our-office" className="absolute top-0 left-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(53,128,121,0.25),transparent_40%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.08),transparent_42%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-secondary-100 font-default font-bold tracking-widest uppercase text-sm mb-4">
            Start the Conversation
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight text-white leading-tight mb-6">
            Have a complex financial, reporting, project, or systems issue?
          </h2>

          <p className="text-lg md:text-xl text-primary-foreground/85 font-default leading-relaxed max-w-3xl mx-auto mb-10">
            RiverBend can help you talk through the situation, identify the
            support needed, and determine a practical next step that fits your
            organization.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" variant="secondary" className="h-12 px-8 rounded-md font-default">
              <Link to="tel:+18079357952">
                <Phone className="mr-2 size-4" />
                (807) 935-7952
              </Link>
            </Button>

            <Button asChild size="lg" className="h-12 px-8 rounded-md bg-secondary hover:bg-secondary/90 text-white font-default">
              <Link to="mailto:info@riverbendcorp.ca">
                <Mail className="mr-2 size-4" />
                Email RiverBend
              </Link>
            </Button>

            <Button asChild size="lg" variant="outline" className="h-12 px-8 rounded-md border-white/60 text-white bg-transparent hover:bg-white hover:text-primary-500 font-default">
              <Link to="#connect-with-our-office">
                Send an Inquiry
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}